import React, { Suspense, lazy } from 'react';
import Header from '../../Components/Common/Header';
import Banner from '../../Components/Homepage/Banner';
import { Helmet } from 'react-helmet-async';
import './Homepage.css';

// Lazy-loaded components
const Package = lazy(() => import('../../Components/Homepage/Package'));
const StartMyBusiness = lazy(() => import('../../Components/Homepage/StartMyBusiness'));
const WhatsCorpquick = lazy(() => import('../../Components/Homepage/WhatsCorpquick'));
const Straightforward = lazy(() => import('../../Components/Homepage/Straightforward'));
const Testimonial = lazy(() => import('../../Components/Homepage/Testimonial'));
const Footer = lazy(() => import('../../Components/Common/Footer'));

const Homepage = () => {
  return (
    <>
      <Helmet>
        <title>Home | CorpQuick</title>
        <meta name="description" content="Homepage of CorpQuick" />
      </Helmet>

      <Header />
      <Banner />  {/* Critical hero section - load immediately */}

      {/* Lazy-load below-the-fold sections */}
      <Suspense fallback={<div className="loading">Loading content...</div>}>
        <Package />
        <StartMyBusiness />
        <WhatsCorpquick />
        <Straightforward />
        <Testimonial />
        <Footer />
      </Suspense>
    </>
  );
};

export default Homepage;
